import styles from './styles.module.scss';
import { Typography } from '@mui/material';
import { ReactNode } from 'react';
import clsx from 'clsx';

type InputProps = {
  icon: ReactNode;
  title: string;
  subtitle: ReactNode;
  button?: ReactNode;
  onClick?: () => void;
};

export const ContentListItem = ({
  icon,
  title,
  subtitle,
  button,
  onClick,
}: InputProps) => {
  return (
    <div
      className={clsx(styles.root, {
        [styles.clickable]: !!onClick,
      })}
      onClick={onClick}
    >
      <div className={styles.icon}>{icon}</div>
      <div className={styles.text}>
        <Typography>{title}</Typography>
        {subtitle}
      </div>
      {button && <div className={styles.actions}>{button}</div>}
    </div>
  );
};
